module.exports = __webpack_public_path__ + "img/Frente-37-02 open.e6511c27.jpg";